/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum DockerRunScheduledState {
    OPEN = 'OPEN',
    LOCKED = 'LOCKED',
    DONE = 'DONE',
    CANCELED = 'CANCELED'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const DockerRunScheduledStateValidatorShape = [
    'OPEN',
    'LOCKED',
    'DONE',
    'CANCELED'
];
export const DockerRunScheduledStateValidator = yup.mixed().oneOf(DockerRunScheduledStateValidatorShape);
export const DockerRunScheduledStateStringifyShapeProperties = {};
export const DockerRunScheduledStateStringifyShape: StringSchema = {
    title: 'DockerRunScheduledState Stringifier',
    type: 'string'
};
export const DockerRunScheduledStateStringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DockerRunScheduledStateStringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function DockerRunScheduledStateFromJSON(json: any): DockerRunScheduledState {
    return DockerRunScheduledStateFromJSONTyped(json, false);
}
export function DockerRunScheduledStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DockerRunScheduledState {
    return json as DockerRunScheduledState;
}
export function DockerRunScheduledStateToJSON(value?: DockerRunScheduledState | null): any {
    return value as any;
}
